import React, { useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import DesktopMenuItem from "./DesktopMenuItem";
import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import { StyledButton, StyledBox } from "../../../../styled-mui";
import { GetStaticLinksSelector } from "../../../../redux/selectors/category";
import { SvgIconProject } from "../../../svg/iconProject";
import AsyncCall from "../../../../_foundation/gtm/async.service";
import { CLICK } from "../../../../_foundation/constants/gtm";
import { getSite } from "../../../../_foundation/hooks/useSite";
import { LINK_USAGE, NAVIGATION_IDENTIFIERS } from "../../../../constants/marketing";
import DesktopProductsMenu from "./sub-menus/DesktopProductsMenu";
import DesktopInspirationMenu from "./sub-menus/DesktopInspirationMenu";
import DesktopServicesMenu from "./sub-menus/DesktopServicesMenu";
import DesktopOutilsMenu from "./sub-menus/DesktopOutilsMenu";
import { useNavigate } from "react-router";

// COMPONENT MAP FOR LINKS/MENUS HARDCODED FROM FRONTEND BASED ON IDENTIFIER
const menuUiOnHover = {
  [NAVIGATION_IDENTIFIERS.PRODUCTS]: DesktopProductsMenu,
  [NAVIGATION_IDENTIFIERS.INSPIRATIONS]: DesktopInspirationMenu,
  [NAVIGATION_IDENTIFIERS.OUTILS]: DesktopOutilsMenu,
  [NAVIGATION_IDENTIFIERS.POSE_ET_SERVICE]: DesktopServicesMenu,
};

const DesktopMenuBar: React.FC<{ menuLinksData: Record<string, any> }> = ({ menuLinksData }) => {
  const mySite = getSite();
  const navigate = useNavigate();
  const staticLinksRedux: Record<string, any> = useSelector(GetStaticLinksSelector);
  const [selectedMenuItem, setSelectedMenuItem] = useState<string | null>(null);
  const popperRef: React.RefObject<HTMLButtonElement> = useRef<HTMLButtonElement>(null);
  const menuLinks = useMemo(() => {
    const headerLinks = (staticLinksRedux && staticLinksRedux?.headerLinks) || [];
    return [
      {
        usage: LINK_USAGE.STANDARD,
        seo: {
          label: "PRODUITS",
          target: "",
          type: "",
          url: "",
          identifier: NAVIGATION_IDENTIFIERS.PRODUCTS,
        },
      },
      ...headerLinks,
    ];
  }, [staticLinksRedux]);

  return (
    <StyledBox className="expanded-menu-container">
      <StyledGrid container alignItems="center" overflow="hidden" justifyContent="space-between">
        <StyledGrid container item xs>
          <nav aria-label="Main Navigation">
            <StyledBox
              ref={popperRef}
              display="flex"
              direction="row"
              flexWrap="nowrap"
              justifyContent="flex-start"
              alignContent="flex-start"
              sx={{ flexBasis: { md: "inherit", lg: "auto" } }}
              ml={11}>
              {menuLinks.map((item: Record<string, any>, index: number) => (
                <DesktopMenuItem
                  key={item?.seo?.label || index}
                  index={index}
                  popperRef={popperRef}
                  isMenu={item?.usage !== LINK_USAGE.PROMO}
                  menuItem={item}
                  selectedMenuItem={selectedMenuItem}
                  setSelectedMenuItem={setSelectedMenuItem}
                  menuLinksData={menuLinksData}
                  OnHoverUI={menuUiOnHover?.[item?.seo?.identifier] || null}
                />
              ))}
            </StyledBox>
          </nav>
        </StyledGrid>
        <StyledGrid item>
          <StyledButton
            // component="a"
            // href={mySite?.storeCfg?.userData?.PRO_SITE_URL}
            // target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              AsyncCall.sendPageClickCtaEvent({
                event: CLICK.ESCAPE_PRO,
                btn_label: "Escape Pro",
              });
              window.open(mySite?.storeCfg?.userData?.PRO_SITE_URL, "_blank", "noopener,noreferrer");
            }}
            startIcon={<SvgIconProject />}
            size="small"
            color="secondary"
            className="right-margin-8">
            Espace Pro
          </StyledButton>
        </StyledGrid>
      </StyledGrid>
    </StyledBox>
  );
};

export default DesktopMenuBar;
